import * as yup from 'yup';

export const OTP_PAGE_FORM_SCHEMA = yup.object({});
